<template>
  <div id="street-directory">
    <StreetEntry
      v-for="street in streets"
      :key="street.id"
      :street="street"
      :active="String(chosenStr) === String(street.id)"
      :deselected="chosenStr && String(chosenStr) !== String(street.id)"
      @click.native="chooseStreet(street.id)"
    />
  </div>
</template>

<script>
import M2wApi from "@/services/m2w_api";
import StreetEntry from "../page_elements/StreetEntry";

export default {
  name: "StreetDirectoryFrame",
  components: {StreetEntry},

  data() {
    return {
      streets: [],
      chosenStr: 0,
      chosenHnr: 0,
    };
  },

  watch: {
    "$route.query.str_id": function (str_id) {
      const has = str_id != null && String(str_id).trim() !== "";
      this.chosenStr = has ? str_id : 0;

      if (!has) this.$root.$emit("clearStreet3D");
    },
  },

  async activated() {
    this.$Progress.start();

    try {
      const streetObject = await M2wApi.get_streets();
      const dbStreets = streetObject && streetObject.streets ? streetObject.streets : [];

      if (dbStreets.length) {
        this.streets = dbStreets.map((street) => ({
          ...street,
          isOsm: false,
        }));
      } else {
        const coords = this.getCoordsFromRoute();

        if (!coords) {
          this.streets = [];
          return;
        }

        // const osmStreets = await this.getStreetsFromCoordinates(
        //   coords.lat,
        //   coords.lon,
        //   10000
        // );
        const projectInfo = await M2wApi.get_project_info();

        const zoom = Number(this.$route.query.zoom || 13);
        const radius = this.getRadiusFromZoom(zoom);

        const osmStreets = await this.getStreetsFromMaptoolkit(coords.lat, coords.lon, radius, projectInfo);

        this.streets = osmStreets;
      }

      //   this.streets = osmStreets.map((street, index) => ({
      //     id: `osm-${index}`,
      //     name: street.name,
      //     label: street.name,
      //     title: street.name,
      //     numbers: street.numbers,
      //     hnrs: street.numbers,
      //     geom: street.geom,
      //     isOsm: true,
      //   }));
      // }

      this.chosenStr = this.$route.query.str_id || 0;
    } catch (err) {
      console.error("Street loading error:", err);
      this.streets = [];
    } finally {
      this.$Progress.finish();
    }
  },

  // deactivated() {
  //   this.cleanup();
  // },

  destroyed() {
    this.cleanup();
  },

  methods: {
    normalizeText(value) {
      return String(value || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();
    },

    getResultLocality(item) {
      const a = item.address || {};

      return this.normalizeText(a.city || a.town || a.village || a.hamlet || a.suburb || a.municipality || "");
    },
    getCoordsFromRoute() {
      const location = this.$route.query.location;
      if (!location) return null;

      const parts = String(location).split(",");
      if (parts.length < 2) return null;

      const x = Number(parts[0]);
      const y = Number(parts[1]);

      if (!Number.isFinite(x) || !Number.isFinite(y)) return null;

      const lon = (x / 20037508.34) * 180;
      const lat = (Math.atan(Math.exp((y / 20037508.34) * Math.PI)) * 360) / Math.PI - 90;

      return {lat, lon};
    },

    buildStreetLabel(item) {
      const a = item.address || {};

      const street = a.road || item.name || "";

      const locality = a.city || a.town || a.village || a.hamlet || a.suburb || a.municipality || "";

      const county = a.county || a.state_district || a.state || "";

      const country = a.country || "";

      return [street, locality, county, country].filter(Boolean).join(", ");
    },

    normalizeGeojsonGeometry(geometry) {
      if (!geometry || !geometry.coordinates) return null;

      const normalizeCoordinates = (coords) => {
        if (!Array.isArray(coords)) return null;

        if (coords.length === 2 && !Array.isArray(coords[0])) {
          const lon = Number(coords[0]);
          const lat = Number(coords[1]);

          if (!Number.isFinite(lon) || !Number.isFinite(lat)) return null;

          return [lon, lat];
        }

        const nested = coords.map(normalizeCoordinates).filter(Boolean);
        return nested.length ? nested : null;
      };

      const coordinates = normalizeCoordinates(geometry.coordinates);
      if (!coordinates) return null;

      return {
        type: geometry.type,
        coordinates,
      };
    },
    getProjectArea(projectInfo) {
      const name = String(projectInfo.name || "");

      const match = name.match(/^(.+?)\((.+?)\)$/);

      if (!match) {
        return {
          locality: this.normalizeText(name),
          county: "",
        };
      }

      const countyMap = {
        AR: "Arad",
        AB: "Alba",
        BH: "Bihor",
        CJ: "Cluj",
        SM: "Satu Mare",
      };

      return {
        locality: this.normalizeText(match[1]),
        county: this.normalizeText(countyMap[match[2]] || match[2]),
      };
    },

    async getStreetsFromMaptoolkiti(lat, lon, radius = 3000, projectInfo = {}) {
      const lang = (this.$i18n.locale || "ro").split("-")[0];

      const projectArea = this.getProjectArea(projectInfo);

      const wantedLocality = projectArea.locality;
      const wantedCounty = projectArea.county;

      console.log("PROJECT INFO", projectInfo);
      console.log("FILTER", {wantedLocality, wantedCounty});

      const url =
        `https://geocoder.maptoolkit.net/search` +
        `?q=strada` +
        `&lat=${encodeURIComponent(lat)}` +
        `&lon=${encodeURIComponent(lon)}` +
        `&radius=${encodeURIComponent(radius)}` +
        `&countrycodes=ro` +
        `&limit=100` +
        `&polygon=1` +
        `&language=${encodeURIComponent(lang)}` +
        `&api_key=93563e3c-84df-435d-a44e-7a6c24e0d817`;

      const res = await fetch(url);
      const data = await res.json();

      const results = Array.isArray(data) ? data : data.features || data.results || [];

      console.table(
        results.map((item) => ({
          road: item.address?.road,
          locality: this.normalizeText(
            item.address?.city ||
              item.address?.town ||
              item.address?.village ||
              item.address?.hamlet ||
              item.address?.suburb ||
              item.address?.municipality ||
              ""
          ),
          county: this.normalizeText(item.address?.county || item.address?.state_district || item.address?.state || ""),
          display: item.display_name,
        }))
      );

      const seen = new Set();

      return results
        .filter((item) => item.geojson && item.geojson.type)
        .filter((item) => item.address?.road || item.name)
        .filter((item) => {
          const a = item.address || {};

          const locality = this.normalizeText(
            a.city || a.town || a.village || a.hamlet || a.suburb || a.municipality || ""
          );

          const county = this.normalizeText(a.county || a.state_district || a.state || "");

          if (wantedLocality && locality !== wantedLocality) return false;
          if (wantedCounty && !county.includes(wantedCounty)) return false;

          return true;
        })
        .map((item) => {
          const id = `mtk-${item.osm_id || item.place_id}`;
          const name = this.buildStreetLabel(item);
          const geom = this.normalizeGeojsonGeometry(item.geojson);

          return {
            id,
            name,
            label: name,
            title: name,
            numbers: [],
            hnrs: [],
            geom,
            isOsm: true,
            source: "maptoolkit",
            raw: item,
          };
        })
        .filter((street) => street.geom)
        .filter((street) => {
          if (seen.has(street.id)) return false;
          seen.add(street.id);
          return true;
        })
        .sort((a, b) => a.name.localeCompare(b.name));
    },

    getViewboxFromCenter(lat, lon, radiusMeters) {
      const dLat = radiusMeters / 111320;
      const dLon = radiusMeters / (111320 * Math.cos((lat * Math.PI) / 180));

      return [lon - dLon, lat - dLat, lon + dLon, lat + dLat].join(",");
    },

    async getStreetsFromMaptoolkit(lat, lon, radius = 3000, projectInfo = {}) {
      const lang = (this.$i18n.locale || "ro").split("-")[0];
      const projectArea = this.getProjectArea(projectInfo);
      const viewbox = this.getViewboxFromCenter(lat, lon, radius);

      const queries = [
        `strada, ${projectArea.locality}, ${projectArea.county}`,
        `stradă, ${projectArea.locality}, ${projectArea.county}`,
        `str., ${projectArea.locality}, ${projectArea.county}`,
        `drum, ${projectArea.locality}, ${projectArea.county}`,
      ];

      const seen = new Map();

      for (const q of queries) {
        const url =
          `https://geocoder.maptoolkit.net/search` +
          `?q=${encodeURIComponent(q)}` +
          `&viewbox=${encodeURIComponent(viewbox)}` +
          `&countrycodes=ro` +
          `&limit=100` +
          `&polygon=1` +
          `&language=${encodeURIComponent(lang)}` +
          `&api_key=93563e3c-84df-435d-a44e-7a6c24e0d817`;

        const res = await fetch(url);
        const data = await res.json();
        const results = Array.isArray(data) ? data : data.features || data.results || [];

        results.forEach((item) => {
          const streetName = item.address?.road || item.name;
          if (!streetName) return;

          const geom = item.geojson
            ? this.normalizeGeojsonGeometry(item.geojson)
            : item.lat && item.lon
            ? {
                type: "Point",
                coordinates: [Number(item.lon), Number(item.lat)],
              }
            : null;

          if (!geom) return;

          const key = this.normalizeText(streetName);

          if (!seen.has(key)) {
            seen.set(key, {
              id: `mtk-${item.osm_id || item.place_id || key}`,
              name: streetName,
              label: streetName,
              title: streetName,
              numbers: [],
              hnrs: [],
              geom,
              isOsm: true,
              source: "maptoolkit",
              raw: item,
            });
          }
        });
      }

      return Array.from(seen.values()).sort((a, b) => a.name.localeCompare(b.name, "ro"));
    },
    getRadiusFromZoom(zoom) {
      const z = Number(zoom || 13);

      if (z >= 17) return 400;
      if (z >= 16) return 700;
      if (z >= 15) return 1200;
      if (z >= 14) return 2000;
      if (z >= 13) return 3500;
      if (z >= 12) return 6000;

      return 10000;
    },

    async chooseStreet(streetId) {
      const streetObj = this.streets.find((s) => String(s.id) === String(streetId));

      const query = {...this.$route.query};
      delete query.hnr;

      if (String(this.chosenStr) === String(streetId)) {
        delete query.str_id;
        delete query.street_name;
        delete query.wh;
      } else {
        query.str_id = streetId;

        if (streetObj && streetObj.isOsm) {
          query.street_name = streetObj.name;
        }
      }

      const target = {
        name: "pois",
        params: {view: "streets"},
        query,
      };

      const resolved = this.$router.resolve(target);
      if (resolved.route.fullPath === this.$route.fullPath) return;

      await this.$router.push(target).catch((err) => {
        if (err.name !== "NavigationDuplicated") throw err;
      });
    },

    cleanup() {
      const q = {...this.$route.query};

      delete q.hnr;
      delete q.wh;

      const target = {query: q};
      const resolved = this.$router.resolve(target);

      if (resolved.route.fullPath === this.$route.fullPath) return;

      this.$router.replace(target).catch((err) => {
        if (err.name !== "NavigationDuplicated") throw err;
      });
    },
  },

  //   methods: {
  //     getCoordsFromRoute() {
  //       const location = this.$route.query.location;
  //       if (!location) return null;

  //       const parts = String(location).split(",");
  //       if (parts.length < 2) return null;

  //       const x = Number(parts[0]);
  //       const y = Number(parts[1]);

  //       if (!Number.isFinite(x) || !Number.isFinite(y)) return null;

  //       const lon = (x / 20037508.34) * 180;
  //       const lat =
  //         (Math.atan(Math.exp((y / 20037508.34) * Math.PI)) * 360) / Math.PI - 90;

  //       return { lat, lon };
  //     },

  // async getStreetsFromCoordinates(lat, lon, radius = 3000) {
  //   const query = `
  //     [out:json][timeout:25];
  //     (
  //       way(around:${radius},${lat},${lon})["highway"]["name"];
  //       node(around:${radius},${lat},${lon})["addr:street"]["addr:housenumber"];
  //       way(around:${radius},${lat},${lon})["addr:street"]["addr:housenumber"];
  //       relation(around:${radius},${lat},${lon})["addr:street"]["addr:housenumber"];
  //     );
  //     out tags geom;
  //   `;

  //   const response = await fetch("https://overpass-api.de/api/interpreter", {
  //     method: "POST",
  //     body: query,
  //   });

  //   const data = await response.json();
  //   console.log(
  //   "ADDR",
  //   data.elements
  //     .filter(el => el.tags && el.tags["addr:housenumber"])
  //     .map(el => el.tags)
  // );
  //   const grouped = {};

  //   data.elements.forEach(el => {
  //     const tags = el.tags || {};

  //     if (el.type === "way" && tags.highway && tags.name && el.geometry) {
  //       if (!grouped[tags.name]) {
  //         grouped[tags.name] = {
  //           name: tags.name,
  //           numbers: [],
  //           geom: {
  //             type: "LineString",
  //             coordinates: el.geometry.map(point => {
  //               const lon3857 = point.lon * 20037508.34 / 180;
  //               let lat3857 =
  //                 Math.log(Math.tan((90 + point.lat) * Math.PI / 360)) /
  //                 (Math.PI / 180);

  //               lat3857 = lat3857 * 20037508.34 / 180;

  //               return [lon3857, lat3857];
  //             }),
  //           },
  //         };
  //       }

  //       return;
  //     }

  //     if (tags["addr:street"] && tags["addr:housenumber"]) {
  //       const streetName = tags["addr:street"];
  //       const houseNumber = tags["addr:housenumber"];

  //       if (!grouped[streetName]) {
  //         grouped[streetName] = {
  //           name: streetName,
  //           numbers: [],
  //           geom: null,
  //         };
  //       }

  //       if (!grouped[streetName].numbers.includes(houseNumber)) {
  //         grouped[streetName].numbers.push(houseNumber);
  //       }
  //     }
  //   });

  //   return Object.values(grouped)
  //     .filter(street => street.geom)
  //     .map(street => ({
  //       ...street,
  //       numbers: street.numbers.sort((a, b) =>
  //         String(a).localeCompare(String(b), undefined, { numeric: true })
  //       ),
  //     }))
  //     .sort((a, b) => a.name.localeCompare(b.name));
  // },

  //     async chooseStreet(streetId) {
  //       const streetObj = this.streets.find(s => String(s.id) === String(streetId));
  //       const query = { ...this.$route.query };

  //       delete query.hnr;

  //       if (String(this.chosenStr) === String(streetId)) {
  //         delete query.str_id;
  //         delete query.street_name;
  //         delete query.wh;
  //       } else {
  //         query.str_id = streetId;

  //         if (streetObj && streetObj.isOsm) {
  //           query.street_name = streetObj.name;
  //         }
  //       }

  //       const target = {
  //         name: "pois",
  //         params: { view: "streets" },
  //         query,
  //       };

  //       const resolved = this.$router.resolve(target);
  //       if (resolved.route.fullPath === this.$route.fullPath) return;

  //       await this.$router.push(target).catch(err => {
  //         if (err.name !== "NavigationDuplicated") throw err;
  //       });
  //     },

  //     cleanup() {
  //       const q = { ...this.$route.query };

  //       // delete q.str_id;
  //       // delete q.street_name;
  //       delete q.hnr;
  //       delete q.wh;

  //       const target = { query: q };
  //       const resolved = this.$router.resolve(target);

  //       if (resolved.route.fullPath === this.$route.fullPath) return;

  //       this.$router.replace(target).catch(err => {
  //         if (err.name !== "NavigationDuplicated") throw err;
  //       });
  //     },
  //   },
};
</script>